import difference from 'lodash/difference';
import type { ITravelPlannerFilters } from '../models/travel-planner-filters.model';
import { TransportSubMode } from '../../../../../models/transport-sub-mode.enum';
import { TransportMode } from '../../../../../models/transport-mode.enum';

export class FilterHelper {
  public static numberOfFiltersChanged(currentFilters: ITravelPlannerFilters, defaultFilters: ITravelPlannerFilters): number {
    let result = 0;

    if (currentFilters.onlyDirectConnections !== defaultFilters.onlyDirectConnections) {
      result += 1;
    }

    if (currentFilters.viaStopArea !== defaultFilters.viaStopArea) {
      result += 1;
    }

    if (!currentFilters.onlyDirectConnections && currentFilters.interchangeDuration !== defaultFilters.interchangeDuration) {
      result += 1;
    }

    if (currentFilters.includeNearbyStopAreas !== defaultFilters.includeNearbyStopAreas) {
      result += 1;
    }

    if (currentFilters.showWalking !== defaultFilters.showWalking) {
      result += 1;
    }
    if (currentFilters.showBiking !== defaultFilters.showBiking) {
      result += 1;
    }
    if (currentFilters.showBiking && currentFilters.bikingMaxDistance !== defaultFilters.bikingMaxDistance) {
      result += 1;
    }
    if (currentFilters.showBiking && currentFilters.bikingSpeed !== defaultFilters.bikingSpeed) {
      result += 1;
    }

    result += difference(defaultFilters.transportModes, currentFilters.transportModes).length;
    // Handle the fact that train is not shown to the user, it is replaced by regional train and long distance train
    if (currentFilters.transportModes.indexOf(TransportMode.train) === -1) {
      result -= 1;
    }

    const deselectedTransportSubModes = difference(defaultFilters.transportSubModes, currentFilters.transportSubModes);
    result += deselectedTransportSubModes.length;
    // Handle the fact that the regional train and long distance train are grouped into the same checkbox ("other trains")
    if (deselectedTransportSubModes.indexOf(TransportSubMode.regionalTrain) > -1 && deselectedTransportSubModes.indexOf(TransportSubMode.longDistanceTrain) > -1) {
      result -= 1;
    }

    if (currentFilters.showOccupancy !== defaultFilters.showOccupancy) {
      result += 1;
    }

    if (currentFilters.transportModeToDeparture !== defaultFilters.transportModeToDeparture) {
      result += 1;
    }

    return result;
  }
}
